import { Field } from 'formik'
import React from 'react'

const InputTextarea = ({ attr }) => {
    return (
        <div className='flex-1 my-3 px-2'>
            <label htmlFor={attr.name}>{attr.placeholder}</label>
            <Field
                as="textarea"
                name={attr.name}
                placeholder={attr.placeholder}
                className={attr.className}
                columns={3}
            />
        </div>
    )
}

export default InputTextarea;